import anime from 'animejs'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
;(anime as any).suspendWhenDocumentHidden = false
